// extracted by mini-css-extract-plugin
export default {"card":"about_card__N2d++","cards":"about_cards__vSZ18","cardSection":"about_cardSection__qxyAM"};